import { OverlayScrollbars } from "overlayscrollbars";

// Transitions that change how much room an element takes up, unlike colors or
// opacity, which fade on hover all the time.
const SIZE_PROPERTY =
  /^(height|width|min-|max-|padding|margin|grid-template|flex-basis)/;

/**
 * OverlayScrollbars measures its content as soon as it changes, which for an
 * animated change, like a group of rows opening, is before it has finished
 * growing, so the new content wouldn't scroll. This has it measure again
 * whenever an animation of something's size inside it ends. Returns a
 * function that stops it.
 */
export function remeasureAfterTransitions(
  instance: OverlayScrollbars,
): () => void {
  const viewport = instance.elements().viewport;
  const update = (event: TransitionEvent) => {
    // Forced: an unforced update trusts the sizes it last measured, which
    // are the ones that went stale.
    if (SIZE_PROPERTY.test(event.propertyName)) instance.update(true);
  };
  viewport.addEventListener("transitionend", update);
  return () => viewport.removeEventListener("transitionend", update);
}
